import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "src/interfaces/User";

interface UsersState {
  users: User[];
  isSubscribed: boolean;
}

const initialState: UsersState = {
  users: [],
  isSubscribed: false,
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
      state.isSubscribed = true;
    },
  },
});

export const { setUsers } = usersSlice.actions;

export default usersSlice.reducer;
